import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Leaf, Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (e2) {
      setError(formatApiError(e2.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-10" data-testid="forgot-brand">
          <div className="w-10 h-10 rounded-2xl bg-sage flex items-center justify-center">
            <Leaf className="w-5 h-5 text-white" strokeWidth={1.6} />
          </div>
          <div>
            <div className="font-display">Mon Cabinet Bien-être</div>
            <div className="text-xs text-muted-soft">by Capsule Patrimoine</div>
          </div>
        </Link>

        <h1 className="font-display text-3xl mb-2">Mot de passe oublié</h1>
        <p className="text-muted-soft mb-8">Renseignez votre email — nous vous enverrons un lien pour choisir un nouveau mot de passe.</p>

        {sent ? (
          <div className="card-soft p-6 space-y-3" data-testid="forgot-sent">
            <div className="w-12 h-12 rounded-2xl bg-sage-light flex items-center justify-center mb-2">
              <Mail className="w-6 h-6 text-sage" strokeWidth={1.5} />
            </div>
            <div className="font-display text-lg">Vérifiez votre boîte mail</div>
            <p className="text-sm text-muted-soft">
              Si un compte existe pour <b>{email}</b>, vous recevrez un email avec un lien valable
              <b> 1 heure </b>. Pensez à regarder dans vos spams.
            </p>
            <Link to="/login" className="text-sm text-sage hover:underline inline-flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-sm font-medium block mb-2">Email</label>
              <input data-testid="forgot-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="vous@cabinet.fr"
                className="input-soft" />
            </div>
            {error && (
              <div className="text-sm rounded-xl px-4 py-3" style={{ backgroundColor: "#FBEEE8", color: "#8B4D3D" }} data-testid="forgot-error">
                {error}
              </div>
            )}
            <button type="submit" disabled={loading} className="btn-sage w-full text-base py-3.5" data-testid="forgot-submit">
              {loading ? "Envoi…" : "Recevoir le lien de réinitialisation"}
            </button>
            <Link to="/login" className="text-sm text-muted-soft hover:text-sage inline-flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" /> Retour à la connexion
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
